import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-right text-caption mt-1"
}

import { computed } from 'vue';
    import type { ValidationRule } from 'vuetify';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AQTextArea',
  props: {
    modelValue: {},
    label: {},
    fieldProps: {},
    counter: {},
    required: { type: Boolean },
    rows: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    rules: {},
    autoGrow: { type: Boolean },
    showCharCount: { type: Boolean },
    maxCharCount: {},
    maxlength: {},
    errorMessages: {},
    clearable: { type: Boolean }
  },
  emits: ["update:modelValue", "blur"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const innerValue = computed({
        get: () => props.modelValue,
        set: (val: string | undefined) => emit('update:modelValue', val ?? ''),
    });
    const computedLabel = computed(() => {
        if (props.required) {
            return `${props.label} *`;
        }
        return props.label;
    });

    const charCount = computed(() => {
        return props.modelValue?.length || 0;
    });

return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_textarea, _mergeProps({
      modelValue: innerValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event))
    }, props.fieldProps, {
      label: computedLabel.value,
      variant: "outlined",
      counter: props.counter,
      rounded: "",
      rows: props.rows,
      "auto-grow": props.autoGrow,
      disabled: props.disabled,
      readonly: props.readonly,
      rules: props.rules,
      "error-messages": props.errorMessages,
      maxlength: props.maxlength,
      clearable: props.clearable,
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (emit('blur', $event)))
    }), null, 16, ["modelValue", "label", "counter", "rows", "auto-grow", "disabled", "readonly", "rules", "error-messages", "maxlength", "clearable"]),
    (props.showCharCount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(charCount.value) + "/" + _toDisplayString(props.maxCharCount), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})